import React from 'react';
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, Icon } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Layout from '../../components/Layout'
import ProgressBar from '../../components/ProgressBar'
import ButtonComponent from '../../components/Button';

import constants from '../../config/constants'

const Main = styled.div`
  padding: 2rem 0 1rem;
  overflow-y: scroll;
  scroll-behavior: smooth;
`

const MainImg  = styled.div`
  padding: 1rem;
  display: flex;
  align-content: center;
  justify-content: center;
  border-radius: 8px;
  height: 250px;
  margin-top: 2rem;
  border: 1.5px solid ${constants.color.lightDark};

  img {
    object-fit: cover;
    object-position: center;
  }
`
const StyledMainButton = styled.div`
  text-align: center;
  width: 100%;
  margin: .5rem 0 2rem;
`;

const StyledButton = styled(Button)`
  height: 30px !important;
  color: ${constants.color.orange} !important;
  background-color: ${constants.color.white} !important;
  border-color: ${constants.color.orange} !important;
  width: 150px !important;
  border-radius: 25px !important;

  span {
    font-family: Thonburi Bold;
    font-size: 14px !important;
  }

  .anticon {
    font-size: 20px;
    transform: rotate(-90deg);
  }
`;

const IDCardLoading = (props) => {

  return (
    <Layout title={'รูปบัตรประชาชน'} backIcon={true} onClick={() => props.history.goBack()}>
      <ProgressBar percent={50}/>
      <Main>
        <h5>กรุณาถ่ายรูปบัตรประชาชนด้วยโทรศัพท์มือถือของคุณ โดยต้องสามารถอ่านและเห็นรายละเอียดบนบัตรได้อย่างชัดเจน </h5>
        <MainImg>
          <LazyLoadImage
            alt=''
            height={'100%'}
            visibleByDefault={true}
            src={props.userInfomations.idCardPicture}
            width={'95%'} />
        </MainImg>
      </Main>
      <StyledMainButton>
        <StyledButton onClick={() => props.history.push('/camera-id-card')}>
          <Icon type="redo" /> อัปโหลดใหม่
        </StyledButton>
      </StyledMainButton>
      <ButtonComponent
        textcolor={constants.color.white}
        bordercolor={constants.color.orange}
        backgroundcolor={constants.color.orange}
        text={'บันทึก'}
        disabled={false}
        onClick={() => props.history.push('/upload-document')}/>
    </Layout>
  )
}


const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const IDCardLoadingWithConnect = connect(mapStateToProps,null)(IDCardLoading)

export default IDCardLoadingWithConnect
